import React from 'react';
import _ from 'lodash';
import NcDlService from '../../../../../service/NcDlService';
import DetailedNcDlModal from './NcDlModal';
import Grid from '../../../../grid/Grid';
import SearchBar from '../../../../searchbar/SearchBar';
import FieldSet from '../../../../fieldset/FieldSet';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';

export default class NcDl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orderRows: [],
      orderHeaders: [],
    };

    this.comboFields = [
      {
        value: 'driversLicenseNumber',
        display: 'Driver License No.',
      },
      {
        value: 'customerId',
        display: 'Customer Id',
      },
    ];
  }

  onOrderSelect(row) {
    const { orderRows = [], } = this.state;
    const selectedOrder = orderRows.find(order => order.raw.id === row.id);
    this.setState({
      selectedOrder: selectedOrder.raw,
    });
  }

  getOrderActivity(event) {
    const { search, combo, } = event;
    this.reset();
    const vm = this;
    const orderRows = [];
    const orderHeaders = [];

    const criteria = {};
    criteria[combo.value] = search.value;

    const allowedKeys = [
      'id',
      'transactionId',
      'driversLicenseNumber',
      'lastName',
      'customerId',
      'orderType',
      'orderDate',
    ];

    NcDlService.getNcDlOrdersBySearchCriteria(criteria)
      .then((response) => {
        const { orders, } = response.data;
        if (orders.length > 0) {
          orders.forEach((order) => {
            const filtered = _.pick(order, allowedKeys);
            const row = Object.values(filtered);
            orderRows.push({
              value: row,
              raw: order,
            });
          });
          allowedKeys.forEach((allowedKey) => {
            orderHeaders.push({
              value: allowedKey,
              display: _.startCase(allowedKey),
            });
          });
        }

        vm.setState({
          orderHeaders,
          orderRows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  formatSelectedRowDisplay = (order) => {
    if (!order) {
      return null;
    }
    return (
      <div>
        <p>{`Selected ID: ${order.id}`}</p>
        <hr />
        <DetailedNcDlModal selectedOrder={order} />
      </div>
    );
  };

  reset() {
    this.setState({
      orderRows: [],
      orderHeaders: [],
      selectedOrder: null,
    });
  }

  render() {
    const {
      orderHeaders = [],
      orderRows = [],
      selectedOrder,
    } = this.state;
    const style = {
      maxHeight: '800px',
      overflowY: 'auto',
    };
    return (
      <div className="container">
        <SearchBar comboFields={this.comboFields} onClick={data => this.getOrderActivity(data)} />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Orders">
            <Grid
              headers={orderHeaders}
              rows={orderRows}
              style={style}
              onRowSelect={data => this.onOrderSelect(data)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
          {this.formatSelectedRowDisplay(selectedOrder)}
        </div>
      </div>
    );
  }
}
